module.exports = __webpack_public_path__ + "static/media/paslon-2.794af82b.jpg";